/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect} from "react";
import BookingCustomerForm from "pages/Front/Booking/components/BookingCustomer/BookingCustomerForm";
import {Company} from "types/entities/Company";
import BookingOverview from "pages/Front/Booking/components/BookingCustomer/BookingOverview";
import {RouteComponentProps, withRouter} from "react-router";
import {useTypedSelector} from "helpers/reducers";
import {appendQueryParams, currencyNumberFormat} from "utils/utility";
import BookingVoucher from "pages/Front/Booking/BookingVoucher";
import {PackageCategory} from "types/enums/PackageCategory";
import TagManager from "react-gtm-module";
import Loader from "components/Loader";
import {useDispatch} from "useDispatch";

interface BookingCustomerProps extends RouteComponentProps {
    company: Company | null;
}

const BookingCustomer = (props: BookingCustomerProps) => {
    const dispatch = useDispatch();
    const selectedPackage = useTypedSelector(state => state.bookingState.bookingProcess.package);
    const selectedPackageItems = useTypedSelector(state => state.bookingState.bookingProcess.selectedPackageItems);
    const customer = useTypedSelector(state => state.bookingState.bookingProcess.customer);
    const packagesCart = useTypedSelector(state => state.bookingState.bookingProcess).packageCart;
    const bookingFilter = useTypedSelector(state => state.bookingState.bookingProcess.filter);
    const transactionTotal = packagesCart ? packagesCart.price / 100 : 0;

    const cartTagManagerArgs = {
        dataLayer: {
            event: "ShoppingCart",
            valueFormatted: currencyNumberFormat(packagesCart?.price),
            transactionTotal: transactionTotal,
            transactionId: packagesCart?.reservation_id,
            paymentItems: packagesCart?.packagesCartItems && packagesCart?.packagesCartItems?.length > 0 ? [...packagesCart?.packagesCartItems] : [],
        },
    };

    useEffect(() => {
        TagManager.dataLayer(cartTagManagerArgs);
    }, []);

    if (selectedPackage === null && selectedPackageItems.length === 0) {
        props.history.replace("/booking" + "?" + appendQueryParams(bookingFilter));
    }

    if (!packagesCart || packagesCart?.packagesCartItems.length === 0) {
        return <Loader />;
    }

    return (
        <div className={"BookingCustomer w-full flex-col"}>
            <BookingCustomerForm company={customer}>
                <BookingOverview />
                {selectedPackage?.category !== PackageCategory.Event && <BookingVoucher isFilter={false} />}
            </BookingCustomerForm>
        </div>
    );
};

export default withRouter(BookingCustomer);
